var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _ellipse, _path4, _rect5, _rect6, _rect7, _rect8, _ellipse2, _path5, _g, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 157,
    viewBox: "0 0 162 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 130C116.899 130 146 100.899 146 65C146 29.1015 116.899 0 81 0C45.1015 0 16 29.1015 16 65C16 100.899 45.1015 130 81 130Z",
    fill: "#F7F9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139 60C142.866 60 146 56.866 146 53C146 49.134 142.866 46 139 46C135.134 46 132 49.134 132 53C132 56.866 135.134 60 139 60Z",
    fill: "#FF7A7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.345 56.1935L138.799 53.6478L136.253 56.1935L135.405 55.345L137.95 52.7993L135.405 50.2536L136.253 49.4051L138.799 51.9507L141.345 49.4051L142.193 50.2536L139.647 52.7993L142.193 55.345L141.345 56.1935Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 122.953,
    width: 91.8958,
    height: 34.0432,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 66.9824,
    y: 130,
    width: 51.4714,
    height: 3.5687,
    rx: 1.78435,
    fill: "#1B3554"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 66.9824,
    y: 136.508,
    width: 37.9083,
    height: 3.5687,
    rx: 1.78435,
    fill: "#1B3554"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 66.9824,
    y: 146.266,
    width: 14.7192,
    height: 3.5687,
    rx: 1.78435,
    fill: "#1B3554"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.485,
    cy: 135.616,
    rx: 8.35416,
    ry: 8.32696,
    fill: "#BAC2CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1464 138.704C50.3053 138.863 50.5131 138.942 50.7213 138.942C50.9294 138.942 51.1372 138.863 51.2962 138.704L55.3619 134.638C55.6795 134.32 55.6795 133.806 55.3619 133.488C55.0444 133.171 54.5297 133.171 54.2121 133.488L50.7213 136.979L48.8567 135.114C48.5392 134.797 48.0244 134.797 47.7069 135.114C47.3894 135.432 47.3894 135.947 47.7069 136.264L50.1464 138.704Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 83.3828,
    width: 91.8958,
    height: 34.0432,
    rx: 13.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 66.9824,
    y: 90.4297,
    width: 51.4714,
    height: 3.5687,
    rx: 1.78435,
    fill: "#1B3554"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 66.9824,
    y: 96.9375,
    width: 37.9083,
    height: 3.5687,
    rx: 1.78435,
    fill: "#1B3554"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 66.9824,
    y: 106.695,
    width: 14.7192,
    height: 3.5687,
    rx: 1.78435,
    fill: "#1B3554"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.485,
    cy: 96.0457,
    rx: 8.35416,
    ry: 8.32696,
    fill: "#BAC2CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1464 99.1334C50.3053 99.2924 50.5131 99.3717 50.7213 99.3717C50.9294 99.3717 51.1372 99.2924 51.2962 99.1334L55.3619 95.0676C55.6795 94.7501 55.6795 94.2354 55.3619 93.9178C55.0444 93.6003 54.5297 93.6003 54.2121 93.9178L50.7213 97.4083L48.8567 95.5441C48.5392 95.2266 48.0244 95.2266 47.7069 95.5441C47.3894 95.8617 47.3894 96.3764 47.7069 96.694L50.1464 99.1334Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4723_28193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8603 27.0526L119.578 37.9416C123.619 38.5602 126.896 41.3847 126.896 44.246V63.3591C126.896 66.2204 123.619 69.0408 119.578 69.6542L43.4024 77.7403C39.3607 78.2565 35 74.8641 35 69.4989V35.2858C35 29.9205 38.8186 26.5318 42.8603 27.0526Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7668 42.6598L116.669 45.9905C117.655 46.0625 118.454 46.736 118.454 47.4946C118.454 48.2533 117.655 48.8306 116.669 48.7842L68.7668 46.6346C67.7813 46.5926 66.9824 45.6594 66.9824 44.5503C66.9824 43.4412 67.7813 42.5947 68.7668 42.6598Z",
    fill: "#1B3554"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7668 49.8989L103.106 50.7315C104.092 50.7562 104.891 51.4692 104.891 52.3238C104.891 53.1784 104.092 53.8713 103.106 53.8714L68.7668 53.8737C67.7813 53.8737 66.9824 52.9747 66.9824 51.8655C66.9824 50.7564 67.7813 49.8759 68.7668 49.8989Z",
    fill: "#1B3554"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7668 60.7734L79.9173 60.314C80.9028 60.2729 81.7017 61.0605 81.7017 62.0732C81.7017 63.0859 80.9028 63.9595 79.9173 64.0243L68.7668 64.7483C67.7813 64.8114 66.9824 63.9634 66.9824 62.8542C66.9824 61.7451 67.7813 60.8135 68.7668 60.7734Z",
    fill: "#1B3554"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6547 58.6269C57.9146 58.5161 62.1785 54.0468 62.1785 48.6456C62.1785 43.2445 57.9146 38.5661 52.6547 38.2001C47.3948 37.8386 43.1309 42.3114 43.1309 48.1864C43.1309 54.0615 47.3948 58.7364 52.6547 58.6269Z",
    fill: "#7DFBA5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1287 52.1875C51.3099 52.385 51.5468 52.4843 51.7841 52.4857C52.0214 52.4872 52.2582 52.3912 52.4395 52.1972L57.0745 47.3425C57.4365 46.972 57.4365 46.3541 57.0745 45.9598C56.7125 45.5643 56.1257 45.5422 55.7637 45.9127L51.7841 50.0683L49.6585 47.7163C49.2965 47.3115 48.7097 47.2949 48.3477 47.6815C47.9857 48.0693 47.9857 48.7136 48.3477 49.1184L51.1287 52.1875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4723_28193",
    x: 0,
    y: 11,
    width: 161.896,
    height: 120.789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.189057 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4723_28193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4723_28193",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/Selection.c4aa2d3a379adf867a1cd7fd440400ea.svg";
export { ForwardRef as ReactComponent };